import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import * as Sentry from "@sentry/react";
import { setAppTimezone } from "./utils/datetime";

// Pin date bucketing to the building's timezone (defaults to Asia/Bangkok),
// optionally overridden per deployment via VITE_APP_TIMEZONE.
setAppTimezone(import.meta.env.VITE_APP_TIMEZONE);

Sentry.init({
  dsn: "https://22de9270f705394aeac51775b7f95057@o4508056774901760.ingest.us.sentry.io/4508205098598400",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
